<template>
  <v-menu
    offset-y
    min-width="100"
    rounded="lg"
    class="assignment-item-context-menu"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        depressed
        color="transparent"
        v-bind="attrs"
        v-on="on"
        rounded
        x-small
        height="40"
        @click="handleAssignmentItemDetails(attrs)"
      >
        <v-icon color="grey">mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list class="pa-0">
      <v-list-item
        v-for="assignmentContextMenuItem in assignmentContextMenu"
        :key="assignmentContextMenuItem.text"
        @click="assignmentContextMenuItem.handleClick()"
        class="d-flex"
      >
        <span class="flex-grow-1 d-flex justify-space-between align-center"
          >{{ assignmentContextMenuItem.text }}
          <v-icon size="20" color="secondary" class="ml-2">{{
            assignmentContextMenuItem.icon
          }}</v-icon></span
        >
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { i18n } from "@/plugins/i18n";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { AssignmentStatusTypes } from "../enums/AssignmentStatusTypes";

export default {
  name: "AssignmentsListItemContextMenu",
  that: this,
  props: {
    assignment: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(ModuleTypes.ASSIGNMENTS, [
      "isDeleteAssignmentDialogOpened",
      "isCloseAssignmentDialogOpened",
      "assignmentsListStatus",
      "favoriteAssignment",
      "assignmentItemDetails"
    ]),

    assignmentContextMenu() {
      return [
        {
          text: i18n.tc("assignments.favourite"),
          icon: `${
            this.favoriteAssignment?.isAssignmentFavorite
              ? "mdi-star"
              : "mdi-star-outline"
          }`,
          handleClick: () =>
            this.toggleFavoriteAssignment({
              assignmentId: !this.$route.params.playerId
                ? this.assignmentItemDetails?.assignmentId
                : this.assignmentItemDetails?.playerResponseId,
              organizationId: this.$route.params.orgId,
              playerId: this.$route.params.playerId,
              isAssignmentFavorite: this.favoriteAssignment
                ?.isAssignmentFavorite
            })
        },
        ...(!this.$route.params?.playerId &&
        this.assignmentItemDetails?.progressStatus ===
          AssignmentStatusTypes.OPEN &&
        this.assignment.editable
          ? [
              {
                text: i18n.tc("assignments.edit"),
                icon: "mdi-pencil-outline",
                handleClick: () => {
                  this.closeRightSidebar();
                  return this.toggleCreateAssignmentDialog({
                    isCreateAssignmentDialogOpened: true
                  });
                }
              }
            ]
          : []),
        ...(this.assignmentItemDetails?.progressStatus ===
          AssignmentStatusTypes.OPEN && this.assignment.editable
          ? [
              {
                text: i18n.tc("assignments.close"),
                icon: "mdi-checkbox-marked-outline",
                handleClick: () =>
                  this.toggleCloseAssignmentDialog({
                    isCloseAssignmentDialogOpened: true
                  })
              }
            ]
          : []),
        ...(!this.$route.params?.playerId && this.assignment.editable
          ? [
              {
                text: i18n.tc("assignments.remove"),
                icon: "mdi-trash-can-outline",
                handleClick: () =>
                  this.toggleDeleteAssignmentDialog({
                    isDeleteAssignmentDialogOpened: true
                  })
              }
            ]
          : [])
      ];
    }
  },

  methods: {
    ...mapMutations(ModuleTypes.ASSIGNMENTS, [
      "toggleAssignmentTodoModal",
      "toggleAssignmentFormModal",
      "setAssignmentItemDetails",
      "toggleDeleteAssignmentDialog",
      "toggleCloseAssignmentDialog"
    ]),
    ...mapMutations(ModuleTypes.STORAGE, ["toggleCreateAssignmentDialog"]),
    ...mapMutations(ModuleTypes.ROOT, ["closeRightSidebar"]),
    ...mapActions(ModuleTypes.ASSIGNMENTS, [
      "toggleFavoriteAssignment",
      "fetchFavoriteAssignment"
    ]),
    handleAssignmentItemDetails(state) {
      this.setAssignmentItemDetails(this.assignment);
      if (
        this.$route.params?.playerId &&
        state?.["aria-expanded"] === "false"
      ) {
        this.fetchFavoriteAssignment({
          assignmentId: this.assignment?.playerResponseId,
          playerId: this.$route.params?.playerId
        });
      }
    }
  }
};
</script>

<style scoped>
.assignment-item-context-menu {
  z-index: 100;
}
</style>
